import { createContext } from "react"
import { GetCurrentAccountResponse } from "~/api/generated/usabilityhub-components"

export const CurrentAccountContext =
  createContext<GetCurrentAccountResponse | null>(null)
